import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

// Sunucu geçici olarak yanıt vermiyorsa (yeniden başlatma / yayın / kısa kesinti) üstte ince bir şerit gösterir;
// api.js otomatik yeniden dener, bağlantı dönünce şerit kendiliğinden kalkar. Kullanıcı "site çöktü" sanmaz.
export default function ServerStatusBanner() {
  const [down, setDown] = useState(false);
  useEffect(() => {
    const onDown = () => setDown(true);
    const onUp = () => setDown(false);
    window.addEventListener("ge:server-down", onDown);
    window.addEventListener("ge:server-up", onUp);
    return () => { window.removeEventListener("ge:server-down", onDown); window.removeEventListener("ge:server-up", onUp); };
  }, []);
  if (!down) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[100] flex items-center justify-center gap-2 bg-amber-500 text-white text-xs sm:text-sm font-semibold px-3 py-1.5 shadow" role="status" data-testid="server-status-banner">
      <RefreshCw className="h-3.5 w-3.5 animate-spin" />
      {navigator.onLine === false ? "İnternet bağlantısı yok — bağlantı gelince işleminiz otomatik tekrar denenecek." : "Bağlantı sorunu: sunucuya ulaşılamıyor (zayıf internet ya da sunucu yeniden başlıyor). İşleminiz otomatik olarak tekrar denenecek."}
    </div>
  );
}
